import * as React from "react";
import MuiSelect, {
    SelectProps as MuiSelectProps,
    SelectClassKey as MuiSelectClassKey
} from "@material-ui/core/Select";



export type SelectClassKey = MuiSelectClassKey;

export interface SelectProps extends MuiSelectProps { }

class Select extends React.PureComponent<SelectProps> {
    render() {
        const { ...props } = this.props;
        return <MuiSelect {...props}>
            {this.props.children}
        </MuiSelect>;
    }
}

export default Select;